/**
 * Somatórios por perfil (Devedor/Cliente/HB) a partir de um bloco já
 * normalizado por `dadosPagamentoFactory` (`services/core/processos/
 * fichaFinanceiraValoresDistribuidos.factory.js`).
 *
 * Réplica local da mesma aritmética usada em produção
 * (`src/pages/InspecionarProcesso/FichaFinanceira/FichaFinaceira.jsx`,
 * funções `somatoriosDevedor/Cliente/Hb`) — não importada de lá porque
 * aquele arquivo é uma page de produção, não um service/util exportável, e
 * o protótipo nunca importa de produção (`src/prototipo/CLAUDE.md`, "Nunca
 * o inverso"). Validar contra a tela real ao vivo para o mesmo processo
 * antes de fechar a etapa que introduz este arquivo.
 */
export function somatoriosDevedor(dadosPagamento) {
  if (!dadosPagamento?.valores) return 0;

  const {
    valorSaldoPrincipal = 0,
    valorMulta = 0,
    valorProtesto = 0,
    valorJurosCliente = 0,
    valorJurosABE = 0,
    valorHonorarios = 0,
  } = dadosPagamento.valores;

  return (
    Number(valorSaldoPrincipal)
    + Number(valorMulta)
    + Number(valorProtesto)
    + Number(valorJurosCliente)
    + Number(valorJurosABE)
    + Number(valorHonorarios)
  );
}

export function somatoriosCliente(dadosPagamento) {
  if (!dadosPagamento?.valores) return 0;

  const {
    valorSaldoPrincipal = 0,
    valorMulta = 0,
    valorProtesto = 0,
    valorJurosCliente = 0,
  } = dadosPagamento.valores;

  return (
    Number(valorSaldoPrincipal)
    + Number(valorMulta)
    + Number(valorProtesto)
    + Number(valorJurosCliente)
  );
}

export function somatoriosHb(dadosPagamento) {
  if (!dadosPagamento?.valores) return 0;

  const {
    valorJurosABE = 0,
    valorHonorarios = 0,
  } = dadosPagamento.valores;

  return Number(valorJurosABE) + Number(valorHonorarios);
}
